import React, { useEffect, useState } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { useSelector } from 'react-redux';
import "./PublicAllExpensesContainer.css"
import axios from 'axios';
function PublicAllExpensesContainer() {
  const { currentLocal } = useSelector((state) => state.currentLocal);
  const [data, setData] = useState([])
  const [activeFee, setActiveFee] = useState(null)
  const [activeFeeData, setActiveFeeData] = useState([])
  const getData = async () => {
    try {
      const response = await axios.get(`https://nanosoft.space/taarteb/public/api/expenses?school_id=3`);
      setData(response.data.data);
      // const fiterData=response.data.data.filter((item)=>item?.id==activeFee)
      // setActiveFeeData(fiterData)

      if (response.data.data.length > 0 && !activeFee) {
        setActiveFee(response.data.data[0].id);
        setActiveFeeData([response.data.data[0]]);
      } else {
        const filterData = response.data.data.filter((item) => item?.id === activeFee);
        setActiveFeeData(filterData);
      }
    } catch (error) {

    } finally {
    }
  }
  useEffect(() => {
    getData()
  }, [activeFee])

  return (
    <div className='my-5'>
      <Container>
        <Row>
          <Col md={4}>
            <div className=' bg_main_dark py-3 rounded'>
              <p className='text-white mb-0 px-2'> {currentLocal.home.FeesSchedule}</p>

            </div>
            <ul className='p-0 bg-light rounded list-group'>
              {data && data?.map((item) => {
                return (
                  <li className={activeFee == item?.id ? 'py-2 px-3  text-white list-group-item' : 'py-2 px-3 bg-light list-group-item'} style={{
                    cursor: "pointer",
                    backgroundColor: activeFee == item?.id && "#a79cad"

                  }} onClick={() => setActiveFee(item?.id)}>
                    {
                      item?.grade?.name + " " + item?.grade_category?.name
                    }
                  </li>
                )
              })}
            </ul>
          </Col>
          <Col md={8} className='mt-4'>
            <Container>
              <Row>
                <Col md={7}>
                  <div className='bg_main_dark py-3 rounded d-flex'>
                    <p className='text-white mb-0 px-2 w-50'> {currentLocal.home.namePlaceholder}</p>
                    <p className='text-white mb-0 px-2 w-50'> {currentLocal.home.price}</p>


                  </div>
                  {activeFeeData && activeFeeData?.[0]?.details.map((item) => {
                    return (
                      <div className=' py-3 bg-light d-flex '>
                        <p className='mb-0 px-2 text-end w-50'> {item?.name}</p>
                        <p className=' mb-0 px-2 w-50'> {item?.price}</p>

                      </div>
                    )
                  })}
                </Col>
              </Row>
            </Container>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default PublicAllExpensesContainer